import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { toast } from 'react-hot-toast';

type CreatePublicationPayload = {
  organization_id: string | number;
};

type PublicationResponse = {
  result: {
    id: number | string;
    organization_id: string | number;
    organization_name?: string;
  };
};

export const useCreatePublication = (languageId: number) => {
  const queryClient = useQueryClient();

  const createPublication = (payload: CreatePublicationPayload) =>
    Axios.post<PublicationResponse>(
      POST_URL(languageId.toString()).createLanguageConfigPublication,
      payload
    ).then(res => res.data);

  return useMutation<
    PublicationResponse,
    AxiosError<BaseError>,
    CreatePublicationPayload
  >(createPublication, {
    onSuccess: () => {
      toast.success('Publication created');
      queryClient.invalidateQueries([
        'languageAndConfigPublication',
        languageId
      ]);
    },
    onError: err => {
      const msg =
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (err.response?.data as any)?.message ||
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (err.response?.data as any)?.error_description ||
        err.message ||
        'Failed to create publication';
      toast.error(msg);
    },
    useErrorBoundary: false
  });
};
